import { Injectable } from '@angular/core';
import { Http, QueryHandlerFor, Wrapper } from '@skylab-angular-shared/core';
import { SelloViewsQuery, SelloViewsQueryHandlerBase } from '@skylab-shared/business';

@Injectable({ providedIn: 'root'})
@QueryHandlerFor(SelloViewsQuery)
@Wrapper(SelloViewsQueryHandlerBase)
export class SelloViewsQueryHandler {
	public constructor(
		http: Http
	) { }
}